
import {combineReducers} from 'redux'
import userReducer from './userReducer'
import authReducer from './authReducer'
import quizReducer from './quizReducer'




const rootReducer = combineReducers({
    auth:authReducer,
    user:userReducer,
    quiz:quizReducer
})


export default rootReducer;